import { useRouter } from 'next/router'
import { CloseButton } from '@bridge/ui/components/CloseButton'
import LeftButton from '@bridge/ui/components/LeftButton'
import { isMobile } from 'react-device-detect'

type IconType = 'left' | 'close'

type BackButtonProps = {
	iconType?: IconType
	color?: string
	onClickBack?: () => void
}

const BackButton = ({
	iconType = 'left',
	onClickBack,
	color,
}: BackButtonProps) => {
	const { push, back } = useRouter()

	async function goToMainOrBack () {
		if (!isMobile) {
			const returnUrl = new URLSearchParams(window.location.search).get(
				'return-url',
			)
			if (returnUrl) {
				await push('/')
				return
			}
		}
		back()
	}

	const onPress = onClickBack ?? goToMainOrBack

	if (iconType === 'close') {
		return <CloseButton onClick={onPress} color={color} />
	}

	return <LeftButton onClick={onPress} color={color} />
}

export default BackButton
